
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';
import MapProvider from './MapProvider.vue';
import { MultiPolygon } from '../../../typescript/MapShapes';
import MeasureTool from 'measuretool-googlemaps-v3';
import Vue from 'vue'
@Component({
    components: { MapProvider }
})
export default class MapLoader extends Vue {
    geocoderInstance: google.maps.Geocoder | null = null;
    google: any = null;
    map: google.maps.Map | null = null;
    @Prop()
    mapConfig: google.maps.MapOptions;
    @Prop()
    customClass: String;
    @Prop()
    apiKey: string;
    activeBtn: number = 1;
    showNav: boolean = true;
    measureTool: any = null;
    featureStyleOptions: google.maps.FeatureStyleOptions = {
        strokeColor: '#810FCB',
        strokeOpacity: 1.0,
        strokeWeight: 3.0,
        fillColor: '#810FCB',
        fillOpacity: 0.5
    }
    localityLayer: any = null;

    @Prop({ default: false }) showLabel: boolean;
    created() {
        let self = this;
        
        const loader = new Loader({
            apiKey: this.apiKey,
            version: "3.64",
            libraries: ["drawing", "places"]
        });
        loader
        .importLibrary('maps')
        .then((google) => {
            this.google = google;
            this.initializeMap();
        })
        .catch((e) => {
            
        });
    }
    

    async initializeMap() {
        const mapContainer = this.$el.querySelector('#map');
        await google.maps.importLibrary("marker");
        const { Map } = this.google;

        let self = this;
        this.map = new Map(mapContainer, {
           
            ...self.mapConfig,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            mapId: "767ca5f256dba95d",
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            controlSize: 25
        });

        if (this.map) {
            this.map.getStreetView().setOptions({
                addressControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                }
            });
            this.localityLayer = this.map.getFeatureLayer('ADMINISTRATIVE_AREA_LEVEL_2' as google.maps.FeatureType);
            
            this.measureTool = new MeasureTool(this.map, {
                showSegmentLength: true,
                tooltip: true,
                unit: 'metric',
                contextMenu: true
            });

            this.measureTool.addListener('measure_start', () => {
                this.onMeasureStart();
            });

            this.measureTool.addListener('measure_end', () => {
                this.onMeasureEnd();
            });
        }
        
        this.mapInitialized();
        this.showDepartmentLimits();
        // this.initializeGeocoder();
    }

    @Emit()
    departmentLimits(departmentPolygon: MultiPolygon){}

    async showDepartmentLimits() {
        let departmentPolygon = await localStorage.getItem('department_polygon');

        if(departmentPolygon){
            this.departmentLimits(JSON.parse(departmentPolygon));
        }
        
    }


    @Emit()
    cityBoundsLoaded({ location, viewport }){}


    styleBoundary(placeid) {
        const departmentLimitsStyle: google.maps.FeatureStyleOptions = {
            strokeColor: '#ff0000',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            fillColor: '#FF0000',
            fillOpacity: 0
        };

        if(this.localityLayer !== null){
            this.localityLayer.style = (params) => {
                    if (params.feature.placeId == placeid) {
                    return departmentLimitsStyle;
                }
            }
        }
    }

    @Emit()
    onMeasureStart(){
        
    }
    @Emit()
    onMeasureEnd(){}

    @Emit()
    mapInitialized(){}

    get mapObject(): any {
        return this.map;
    }

    get googleObject(): any {
        return this.google;
    }
}
